export { formatCNPJ } from './CNPJ';
export { formatCPF } from './CPF';
export { Competencia, DataBR } from './DATA';
export { formatNUMBER } from './NUMBER';
export { formatPercentual } from './PERCENTUAL';
export { formatMaskPhone, formatTELEFONE } from './TELEFONE';
